
import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { URLS } from "../../constants/constants";
import { AuthService } from "../../../common/services/auth.service";
import { GetCountOfContentItemsResponseDto } from "../dtos/get-count-of-content-items.response.dto";
import { GetContentItemsResponseDto } from "../dtos/get-content-items.response.dto";
import { ToolsDto } from "../../tools/dtos/tools.dto";


@Injectable()
export class LessonsToolsMappingService {
private http = inject(HttpClient);
//TODO: need to figure this, check RDI-648
    
    getCountOfContentItemsForLesson(coursecode:string) : Promise<GetCountOfContentItemsResponseDto>{
        
        return firstValueFrom(this.http.get<GetCountOfContentItemsResponseDto>(`${URLS.GET_LESSON_CONTENT_ITEMS_COUNT_API}/${coursecode}`)); 
    }
     getContentItemsForLesson(courseCode:string) : Promise<GetContentItemsResponseDto[]>{
        
        return firstValueFrom(this.http.get<GetContentItemsResponseDto[]>(`${URLS.GET_LESSON_CONTENT_ITEMS_API}/${courseCode}`)); 
    }
    getToolForThisCourseCode(courseCode:string){
        return firstValueFrom(this.http.get<ToolsDto>(`${URLS.GET_TOOL_MAPPED_TO_COURSE_API}/${courseCode}`, {
        })); 
    }
}